import { TruncatedTextCell } from '@/creditflowresearch/ui/common/components/DataCells';
import { useTableDictionaries } from '@/creditflowresearch/application/TableDictionaries';

interface IMarketCellProps {
  marketIds: string[] | null | undefined,
}

const MarketCell = ({ marketIds }: IMarketCellProps) => {
  const dictionaries = useTableDictionaries();

  if (!marketIds || marketIds.length === 0) {
    return (<>-</>);
  }

  const accessor = dictionaries.markets;
  const names = marketIds
    .map((id) => accessor?.getById(id)?.name ?? id)
    .join(', ');

  return (<TruncatedTextCell value={ names } />);
};

export default MarketCell;
